'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	if (Object.assign !== polyfill) {
		define(Object, { assign: polyfill });
	}
	return polyfill;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/alt-container/~/object.assign/shim.js
 ** module id = 170
 ** module chunks = 1
 **/